import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { MaintenanceService } from 'mbs-ui-shared@services/maintenance.service';
import { of } from 'rxjs';

export const MaintenanceActivateChild: CanActivateChildFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const maintenanceService = inject(MaintenanceService);

  const isMaintenancePage = next.routeConfig.path === 'Maintenance';
  const targetUrl = isMaintenancePage ? next.queryParamMap.get('page') : state.url;

  const maintenance = maintenanceService.getMaintenance(targetUrl);

  if (maintenance) {
    if (!isMaintenancePage) {
      return router.navigate([RoutingPath.Maintenance], { queryParams: { page: targetUrl } });
    }
  } else if (isMaintenancePage) {
    router.navigateByUrl(targetUrl);
  }

  return of(true);
};
